import classNames from 'classnames';
import { FlexGrid } from 'yoso';
import { PlaceholderCard } from '~/components/Card/Placeholder';
import { BaseError } from '~/components/Error/BaseError';
import { useEvolutions } from '~/components/Evolve/Evolve.hooks';
import { EvolutionStatusCard } from '~/components/Evolve/Status/Card/EvolutionStatusCard';
import { PlaceholderGrid } from '~/components/Grid/Placeholder/PlaceholderGrid';
import styles from './EvolutionStatusList.module.scss';

export type EvolutionStatusListProps = {
  className?: string;
};

export const EvolutionStatusList = ({ className }: EvolutionStatusListProps) => {
  const {
    data: { getReady },
    isFetched,
  } = useEvolutions();

  if (isFetched && getReady.length === 0) throw new BaseError('EMPTY');

  return (
    <PlaceholderGrid
      className={classNames(styles.root, className)}
      placeholder={<PlaceholderCard type="logo" shadow className={styles.placeholder} />}>
      {getReady.map((evolution) => (
        <FlexGrid key={evolution.tokenType}>
          <EvolutionStatusCard {...evolution} />
        </FlexGrid>
      ))}
    </PlaceholderGrid>
  );
};
